/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { AddEditServerMessageRequestBody } from '../model/addEditServerMessageRequestBody';
import { ServerMessageInfoWrapper } from '../model/serverMessageInfoWrapper';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {SetBlacklistDomainSystemRequestBody} from '../model/setBlacklistDomainSystemRequestBody';
import {GroupThresholdEntry} from '../model/groupThresholdEntry';
import {SetBlacklistDomainSystemGroupThresholdRequestBody} from '../model/setBlacklistDomainSystemGroupThresholdRequestBody';


@Injectable()
export class WebtoolsSettingsService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Add a server message
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addServerMessage(body?: AddEditServerMessageRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addServerMessage(body?: AddEditServerMessageRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addServerMessage(body?: AddEditServerMessageRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addServerMessage(body?: AddEditServerMessageRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.getBasePath()}/api/webtools/v1/settings/server-message`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the text for the server message
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServerMessageInfo(observe?: 'body', reportProgress?: boolean): Observable<ServerMessageInfoWrapper>;
    public getServerMessageInfo(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServerMessageInfoWrapper>>;
    public getServerMessageInfo(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServerMessageInfoWrapper>>;
    public getServerMessageInfo(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServerMessageInfoWrapper>(`${this.getBasePath()}/api/webtools/v1/settings/server-message/text`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

  /**
   * Set the config param 'blacklistDomainSystemFlag'
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setBlacklistDomainSystemFlag(body?: SetBlacklistDomainSystemRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public setBlacklistDomainSystemFlag(body?: SetBlacklistDomainSystemRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public setBlacklistDomainSystemFlag(body?: SetBlacklistDomainSystemRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public setBlacklistDomainSystemFlag(body?: SetBlacklistDomainSystemRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


    let headers = this.getDefaultHeaders();

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<any>(`${this.getBasePath()}/api/webtools/v1/settings/blacklist-domain-system`,
      body,
      {
        // withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Return the blacklist-domain-system flag
   *
   * @param observe set whether or not to return the data Observable as the body, response, or events. Defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBlacklistDomainSystemFlagEnabled(observe?: 'body', reportProgress?: boolean): Observable<boolean>;
  public getBlacklistDomainSystemFlagEnabled(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
  public getBlacklistDomainSystemFlagEnabled(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
  public getBlacklistDomainSystemFlagEnabled(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.getDefaultHeaders();

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<boolean>(`${this.getBasePath()}/api/webtools/v1/settings/blacklist-domain-system`, {
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Get the list of group thresholds
   *
   * @param observe set whether or not to return the data Observable as the body, response, or events. Defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBlacklistDomainSystemGroupThresholdList(observe?: 'body', reportProgress?: boolean): Observable<GroupThresholdEntry[]>;
  public getBlacklistDomainSystemGroupThresholdList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GroupThresholdEntry[]>>;
  public getBlacklistDomainSystemGroupThresholdList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GroupThresholdEntry[]>>;
  public getBlacklistDomainSystemGroupThresholdList(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.getDefaultHeaders();

    return this.httpClient.get<GroupThresholdEntry[]>(`${this.getBasePath()}/api/webtools/v1/settings/blacklist-domain-system/group-threshold-list`, {
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Set the group threshold for a specific group
   *
   * @param groupId The ID of the group
   * @param requestBody The request body containing the threshold value
   * @param observe set whether or not to return the data Observable as the body, response, or events. Defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBlacklistDomainSystemGroupThreshold(groupId: string, requestBody: SetBlacklistDomainSystemGroupThresholdRequestBody, observe?: 'body', reportProgress?: boolean): Observable<void>;
  public updateBlacklistDomainSystemGroupThreshold(groupId: string, requestBody: SetBlacklistDomainSystemGroupThresholdRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<void>>;
  public updateBlacklistDomainSystemGroupThreshold(groupId: string, requestBody: SetBlacklistDomainSystemGroupThresholdRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<void>>;
  public updateBlacklistDomainSystemGroupThreshold(groupId: string, requestBody: SetBlacklistDomainSystemGroupThresholdRequestBody, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.getDefaultHeaders();
    headers = headers.set('Content-Type', 'application/json');

    return this.httpClient.put<void>(`${this.getBasePath()}/api/webtools/v1/settings/blacklist-domain-system/group-threshold/${groupId}`, requestBody, {
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }
}

